(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bbb-mega-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    var SPACE_BETWEEN = 16;
    var obs = null;

    function initEl(el) {
      if (!el || el.swiper || typeof window.Swiper === 'undefined') return;
      new window.Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: SPACE_BETWEEN,
        freeMode: { enabled: true },
        watchOverflow: true,
        resistanceRatio: 0.65
      });
    }

    function allReady() {
      var nodes = document.querySelectorAll('[data-bbb-bestsellers-swiper]');
      if (!nodes.length) return false;
      for (var i = 0; i < nodes.length; i++) {
        if (!nodes[i].swiper) return false;
      }
      return true;
    }

    function scan() {
      if (typeof window.Swiper === 'undefined') return;
      document.querySelectorAll('[data-bbb-bestsellers-swiper]').forEach(initEl);
      if (allReady() && obs) {
        obs.disconnect();
        obs = null;
      }
    }

    function updateOpen() {
      document.querySelectorAll('[data-bbb-bestsellers-swiper]').forEach(function (el) {
        if (el.swiper) el.swiper.update();
        else initEl(el);
      });
    }

    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof window.Swiper !== 'undefined') {
        clearInterval(timer);
        scan();
      } else if (attempts > 80) {
        clearInterval(timer);
      }
    }, 50);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan);
    } else {
      scan();
    }

    document.addEventListener('click', function (evt) {
      if (!evt.target.closest('.mobile-nav-toggle')) return;
      setTimeout(updateOpen, 50);
      setTimeout(updateOpen, 400);
    });

    obs = new MutationObserver(scan);
    obs.observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
